"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SAVED_CARD_WIDTH = exports.SAVED_CARD_HEIGHT = exports.INTIAL_EXPIRY_DATE_FORMAT = exports.INITIAL_VALUES = exports.FIELDS = exports.EXPIRY_DATE_FORMAT = exports.DEFAULT_TRANSLATIONS = exports.DEFAULT_DATA = exports.CARD_TYPE_BG_DEFAULT = exports.CARD_TYPE_BG = exports.CARD_LOGO = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
var SAVED_CARD_WIDTH = '320px';
exports.SAVED_CARD_WIDTH = SAVED_CARD_WIDTH;
var SAVED_CARD_HEIGHT = '205px';
exports.SAVED_CARD_HEIGHT = SAVED_CARD_HEIGHT;
var INTIAL_EXPIRY_DATE_FORMAT = 'mmyyyy';
exports.INTIAL_EXPIRY_DATE_FORMAT = INTIAL_EXPIRY_DATE_FORMAT;
var EXPIRY_DATE_FORMAT = 'mm/yy';
exports.EXPIRY_DATE_FORMAT = EXPIRY_DATE_FORMAT;
var DEFAULT_TRANSLATIONS = {
  cardHolder: 'Cardholder',
  expires: 'Expires',
  defaultTag: 'Default',
  cvvLabel: 'CVC/CVV',
  expiryDateLabel: 'Expires',
  defaultCardLabel: 'Set as default card',
  modalTitle: 'What is default payment',
  modalDescription:
  // eslint-disable-next-line max-len
  "We'll make this your default payment method for all airasia products & services. For example, express checkout, default payment checkout and many more.",
  processingFeeLabel: 'Processing fee'
};
exports.DEFAULT_TRANSLATIONS = DEFAULT_TRANSLATIONS;
var DEFAULT_DATA = {
  CardType: 'VI',
  CreditCard: '111111XXXXXX1111',
  ExpiryDate: '012023',
  AccountHolder: 'Kho Zhi Yuen',
  PreferredCard: true,
  VirtualNo: '1111111111111'
};
exports.DEFAULT_DATA = DEFAULT_DATA;
var CARD_TYPE_BG = {
  VI: 'https://static.stgairasia.com/payments/account/images/bg-visa.svg',
  VH: 'https://static.stgairasia.com/payments/account/images/bg-visa.svg',
  MC: 'https://static.stgairasia.com/payments/account/images/bg-master-card.svg',
  MD: 'https://static.stgairasia.com/payments/account/images/bg-master-card.svg',
  UP: 'https://static.stgairasia.com/payments/account/images/bg-union-pay.svg',
  JB: 'https://static.stgairasia.com/payments/account/images/bg-jcb.svg',
  AX: 'https://static.stgairasia.com/payments/account/images/bg-amex.svg',
  BM: 'https://static.stgairasia.com/payments/account/images/bg-bigpay.svg'
};
exports.CARD_TYPE_BG = CARD_TYPE_BG;
var CARD_LOGO = {
  AX: 'https://static.airasia.com/payments/icons/payment/30.png',
  BM: 'https://static.airasia.com/payments/icons/payment/1.png',
  JB: 'https://static.airasia.com/payments/icons/payment/29.png',
  MC: 'https://static.airasia.com/payments/icons/payment/5.png',
  MD: 'https://static.airasia.com/payments/icons/payment/5.png',
  VI: 'https://static.airasia.com/payments/icons/payment/4.png',
  VH: 'https://static.airasia.com/payments/icons/payment/4.png'
};
exports.CARD_LOGO = CARD_LOGO;
var FIELDS = {
  cvv: {
    label: DEFAULT_TRANSLATIONS.cvv,
    name: 'cvv'
  }
};
exports.FIELDS = FIELDS;
var INITIAL_VALUES = _objectSpread({}, Object.keys(FIELDS).reduce(function (acc, curr) {
  acc[curr] = '';
  return acc;
}, {}));
exports.INITIAL_VALUES = INITIAL_VALUES;
var CARD_TYPE_BG_DEFAULT = 'https://static.stgairasia.com/payments/account/images/bg-default.svg';
exports.CARD_TYPE_BG_DEFAULT = CARD_TYPE_BG_DEFAULT;